import { render, staticRenderFns } from "./establishment_tabs.vue?vue&type=template&id=53f34037"
import script from "./establishment_tabs.vue?vue&type=script&lang=js"
export * from "./establishment_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports